module.exports = __webpack_public_path__ + "img/img-business-pay-sec-03-01.png";